import React, { ReactNode, forwardRef } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { ChipField } from '../types';
import { SelectChip } from './SelectChip';
import { DateChip } from './DateChip';
import { TextInputChip } from './TextInputChip';

type ChipComponentProps<T extends string> = ControllerRenderProps<any, T> &
  Pick<ChipField<any>, 'type' | 'options' | 'inputPlaceholder'> & {
    label: string;
    externalOnChange?: (data: any) => void;
    tooltipTitle?: string | ReactNode;
    disabled?: boolean;
  };

export const ChipComponent = forwardRef<
  HTMLElement,
  ChipComponentProps<string>
>(({ type, label, options, inputPlaceholder, ...props }, ref) => {
  switch (type) {
    case 'singleSelect':
      return <SelectChip label={label} {...props} options={options} />;
    case 'multiSelect':
      return <SelectChip isMulti label={label} {...props} options={options} />;
    case 'date':
      return <DateChip label={label} {...props} options={options} />;
    case 'textInput':
      return (
        <TextInputChip
          label={label}
          placeholder={inputPlaceholder}
          {...props}
        />
      );
    default:
      return null;
  }
});

ChipComponent.displayName = 'ChipComponent';
